import type { CaseDefinition } from "../../domain/types/index.js";

type RewardSpec = Pick<CaseDefinition, "size" | "grantsOrganization">;

const RECOVERY_LABEL: Record<"small" | "medium" | "large", string> = {
  small: "疲労を2回復",
  medium: "疲労を3回復",
  large: "疲労を全回復",
};

export function clearRewardTitle(spec: RewardSpec): string {
  return spec.grantsOrganization ? "クリア報酬（組織基盤あり）" : "クリア報酬";
}

export function clearRewardCopy(spec: RewardSpec): string {
  const recovery = RECOVERY_LABEL[spec.size === "boss" ? "large" : spec.size];
  const cardLine = `提示された3枚からカードを1枚取得するか、${recovery}を選べます。`;
  if (!spec.grantsOrganization) return cardLine;
  return `成功すると組織基盤を1つ獲得できます。${cardLine}`;
}
